/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import { organizationSubscriptionSchema } from "./organizationSubscriptionSchema.ts";

export const orgOrganizationsSubscriptionRetrievePathOrgIdSchema = z.uuid();

export const orgOrganizationsSubscriptionRetrieveQueryOrgUnitSchema = z
	.uuid()
	.optional()
	.describe("ID точки организации. Если задан — сначала ищется подпискадля этой точки, иначе fallback на подписку организации.");

export const orgOrganizationsSubscriptionRetrieveStatus200Schema = organizationSubscriptionSchema.describe("Описание конфигурации подписки организации.");

export const orgOrganizationsSubscriptionRetrieveStatus404Schema = z.any();

export const orgOrganizationsSubscriptionRetrieveResponseSchema = z.union([
	orgOrganizationsSubscriptionRetrieveStatus200Schema,
	orgOrganizationsSubscriptionRetrieveStatus404Schema,
]);
